export default {
  General: {
    Email: "E-mail",
    Send: "Invia",
    Done: "Fine",
    Finish: "Fine",
    Try_again: "Riprova",
    or: "o"
  },
  SamsungType: {
    bixby: "Con Bixby",
    no_bixby: "Senza Bixby",
    home_button: "Con il tasto Home"
  },
  sendEmail: {
    repair_tip1: "Questo modello non può essere riparato con l'app per dispositivi mobili. Riceverai una soluzione desktop tramite e-mail.",
    check_tip1: "Il controllo del dispositivo non può essere completato solo con l’app mobile. Ti invieremo la soluzione desktop via email.",
    tip1: "Questo modello non può essere sbloccato con l'app per dispositivi mobili. Riceverai una soluzione desktop tramite e-mail.",
    tip2: "Per una migliore percentuale di successo, collega il telefono al computer con un cavo dati.",
    enter_address: "Inserisci il tuo indirizzo e-mail.",
    enter_correct_address: "Si prega di inserire l'indirizzo e-mail corretto.",
    confidential: "Il tuo indirizzo e-mail verrà mantenuto strettamente riservato.",
    open_link: "Apri {0} su un browser qualsiasi del computer per scaricare Dr.Fone.",
    has_sent: "Il messaggio e-mail è stato inviato",
    almost: "Ci siamo quasi",
    step1: "Passaggio 1",
    open_email: "Apri l'e-mail sul tuo computer e utilizza il collegamento inviato per scaricare la versione desktop di Dr.Fone.",
    step2: "Passaggio 2",
    repair_launch_tip: "Avviate Dr.Fone System Repair ed effettuate l'accesso al vostro account per utilizzare la funzione di riparazione.",
    check_launch_tip: "Installa la versione desktop di Dr.Fone e accedi con lo stesso account. Fai clic su \"My Device\" e segui le istruzioni sullo schermo per collegare il dispositivo. Una volta connesso, fai clic su \"Device Detail\" per visualizzare i risultati dettagliati del controllo.",
    launch_tip: "Avvia la funzione di sblocco di Dr.Fone e accedi al tuo account per utilizzare la funzione di sblocco.",
    contact_us: "Contattaci per ricevere assistenza."
  },
  Unlock: {
    recoveryMode: "Imposta il dispositivo in modalità di ripristino",
    wipe_cache: "Cancellare la partizione della cache sul dispositivo",
    wipe_data: "Segui le istruzioni per cancellare i dati dal dispositivo",
    completed: "Sblocco completato",
    completed_tip: "Verifica che il blocco dello schermo sia stata rimosso correttamente dal dispositivo. In caso contrario, fai un altro tentativo.",
    contact_us: "Sblocco non riuscito? Contattaci per ricevere assistenza."
  },
  UnlockStep: {
    sa1: "1. Spegni il telefono e mantieni il collegamento al computer ",
    sa2: "2. Tieni premuti contemporaneamente i tasti di aumento del volume + Bixby + tasto di accensione",
    sa3: "3. Rilascia i tasti dopo la visualizzazione del logo Samsung e attendi alcuni secondi",
    sa4: "4. A questo punto, il dispositivo dovrebbe avviarsi in modalità di ripristino. Scegli \"Riavvia nel bootloader\" per accedere alla modalità di download.",
    sb1: "1. Spegni il telefono e mantieni il collegamento al computer",
    sb2: "2. Tieni premuti contemporaneamente i tasti di alimentazione e di aumento del volume",
    sb3: "3. Continua a tenere premuti questi due tasti anche dopo l'avvio del dispositivo per avviare il backup",
    sb4: "4. A questo punto, il dispositivo dovrebbe avviarsi in modalità di ripristino. Scegli \"Riavvia nel bootloader\" per accedere alla modalità di download.",
    sc1: "1. Spegni il telefono e mantieni il collegamento al computer",
    sc2: "2. Tieni premuti contemporaneamente i tasti di aumento del volume + Home + tasto di accensione",
    sc3: "3. Rilascia i tasti dopo la visualizzazione del logo Samsung e attendi alcuni secondi",
    sc4: "4. A questo punto, il dispositivo dovrebbe avviarsi in modalità di ripristino. Scegli \"Riavvia nel bootloader\" per accedere alla modalità di download.",
    s5: "5. Premi il tasto del volume per selezionare \"Cancella dati/Ripristino impostazioni predefinite\", quindi premi il tasto di accensione per confermare",
    s6: "6. Premi il tasto del volume per selezionare \"Sì\", quindi premi il tasto di accensione per confermare",
    s7: "7. Premi \"Cancella partizione cache\" e seleziona \"Sì\"",
    s8: "8. Seleziona \"Riavvia il sistema ora\" e premi il tasto di accensione per confermare. Il riavvio del dispositivo potrebbe richiedere alcuni minuti.",
    common1: "Spegni il telefono.",
    common2: "Premi il tasto di aumento del volume e di accensione per alcuni secondi.",
    common3: "Rilascia tutti i tasti quando sullo schermo viene visualizzata la modalità di ripristino.",
    m4: "Scegli \"Cancella dati\" utilizzando i tasti del volume e di accensione per accettare.",
    m5: "Scegli \"Cancella tutti i dati\".",
    m6: "Scegli \"Conferma\" e attendi la fine del processo.",
    m7: "Torna al menu principale utilizzando il tasto di accensione.",
    m8: "Seleziona \"Riavvia\".",
    m9: "Infine, scegli \"Riavvia nel sistema\".",
    h4: "Scegli \"Cancella dati\" utilizzando i tasti del volume e di accensione per accettare.",
    h5: "Seleziona \"Ripristino impostazioni predefinite\".",
    h6: "Digita la parola \"sì\" e seleziona \"Ripristino impostazioni predefinite\".",
    h7: "Tutti i file verranno rimossi durante questa operazione.",
    h8: "Seleziona \"Indietro\" per tornare al menu principale.",
    h9: "Infine, scegli \"Riavvia\"."
  }
};
